export type { CopilotMessageProps, CopilotMessageSlots, CopilotMessageState } from './components/CopilotMessage/index';
export {
  CopilotMessage,
  copilotMessageClassNames,
  renderCopilotMessage_unstable,
  useCopilotMessageStyles_unstable,
  useCopilotMessage_unstable,
} from './components/CopilotMessage/index';
